
export function formatPrice(price: number) {
    return new Intl.NumberFormat("vi-VN", {
        style: "currency",
        currency: "VND",
    }).format(price);
}

export const fetchImage = async (imageUrl: string) => {
    const ngrokSkipWarning = {
        headers: {
            'ngrok-skip-browser-warning': 'true',
            'accept': '*/*',
        }
    }
    let url = imageUrl
    await fetch(imageUrl, ngrokSkipWarning)
    .then(res => res.blob())
    .then(blob => {
        url = URL.createObjectURL(blob);
    });

    return url
}
